// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-pages-Customers-CustomerList-ListNonLoyalty-ImportingModeModal-__ImportingModeModal___23LBB","dialog":"app-pages-Customers-CustomerList-ListNonLoyalty-ImportingModeModal-__ImportingModeModal___1MY_X"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/CustomerList/ListNonLoyalty/ImportingModeModal/ImportingModeModal.css
// module id = 2303
// module chunks = 0